<template>
  <div>
    <div class="row">
      <template v-if="search">
        <div class="col-md-8 d-flex">
          <b-form-group id="input-group-1" label="Pesquisar" label-for="filter">
            <b-input-group>
              <b-form-input
                id="filter"
                v-model="filter"
                type="text"
                placeholder="Pesquisar..."
              ></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''"
                  >Limpar</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </template>
      <div
        v-if="cadastrar"
        class="col d-flex align-items-center justify-content-end"
      >
        <b-button
          class="btn btn-primary"
          style="margin-right: 10px"
          @click="cadastrar"
        >
          <h6 style="margin: 3px; color: #fbf5f5">Cadastrar</h6>
        </b-button>
      </div>
      <div
        v-if="excelColumns"
        class="col d-flex align-items-center justify-content-end"
      >
        <button class="btn btn-primary" @click="$refs.btnexport.$el.click()">
          <img
            v-if="carregando"
            src="../../assets/images/spinner.svg"
            style="height: 23px; margin-left: 38px; margin-right: 38px"
          />
          <h6 v-if="!carregando" style="margin: 3px; color: #fbf5f5"
            >Exportar Excel</h6
          >

          <vue-excel-xlsx
            ref="btnexport"
            style="display: none"
            :data="excelFields"
            :columns="excelColumns"
            :filename="'dados'"
            :sheetname="'dados'"
          >
          </vue-excel-xlsx>
        </button>
      </div>
    </div>
    <b-table
      striped
      hover
      primary-key="_id"
      :items="tableItems"
      :fields="tablesFields"
      :current-page="
        tableItems.length > 10 ? pageFilter : page !== undefined ? 0 : currentPage
      "
      :per-page="perPage"
      :filter="filter"
      :filter-ignored-fields="ignore"
      :empty-filtered-text="'Nenhum registro para os parâmetros informados.'"
      show-empty
      @filtered="updatePagination"
    >
      <template v-slot:append> </template>
      <template v-slot:empty="scope"> Nenhum registro encontrado! </template>
      <template v-for="(_, slotName) of $scopedSlots" v-slot:[slotName]="scope">
        <slot :name="slotName" v-bind="scope" />
      </template>

      <template
        v-if="!noAction || noAction === false || noAction === undefined || noAction === null"
        v-slot:cell(actions)="row"
      >
        <div class="btn-group mb-2">
          <button
            v-b-tooltip.hover
            title="Editar"
            type="button"
            class="btn btn-light"
            @click="modalEdit(row.item)"
          >
            <i class="uil uil-edit-alt"></i>
          </button>
          <button
          v-if="!hide"
            v-b-tooltip.hover
            :style="
              isRemovePermission === undefined || isRemovePermission === true
                ? 'display:block;'
                : 'display:none;'
            "
            title="Deletar"
            type="button"
            class="btn btn-light"
            @click="modalDelete(row.item._id)"
          >
            <i class="uil uil-trash-alt"></i>
          </button>
        </div>
      </template>
    </b-table>
    
    <b-pagination
    v-if="tableItems.length > 10"
      v-model="pageFilter"
      size="md"
      :total-rows="filter ? rows : tableItems.length"
      :per-page="perPage"
    />
    <b-pagination
    v-else
    v-model="currentPage"
    size="md"
    :total-rows="filter && filter !== '' ? rows : countRows ? countRows : tableItems.length"
    :per-page="perPage"
    />
    <b-modal v-model="modal" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja excluir este registro?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="modal = false">Não</b-button>
        <b-button variant="danger" @click="handleDelete">Sim</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import alertMixin from '@/src/mixins/alertMixin'
export default {
  name: 'Table',
  mixins: [alertMixin],
  props: [
    'hide',
    'carregando',
    'tableItems',
    'tablesFields',
    'excelColumns',
    'excelFields',
    'countRows',
    'onPaginate',
    'noAction',
    'search',
    'isRemovePermission',
    'page',
    'ignore',
    'cadastrar'
  ],
  data() {
    return {
      rows: 0,
      currentPage: 1,
      perPage: 10,
      pageFilter: 1,
      modal: false,
      filter: '',
      itemId: '',
    }
  },
  watch: {
    currentPage() {
      this.$emit('onPaginate', this.currentPage - 1)
    },
  },

  methods: {
    updatePagination(filteredItems) {
      this.rows = filteredItems.length;
      this.currentPage = 1;
    },
    modalDelete(item) {
      this.modal = true
      this.itemId = item
    },

    handleDelete() {
      this.$emit('onDelete', this.itemId)
      this.itemId = null
      this.modal = false
    },

    modalEdit(item) {
      this.$emit('onEdit', item)
    },
  },
}
</script>

<style></style>
